import { useMutation, useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api/client';
import { getActiveTenantId } from '@/lib/tenant';
import type {
  BalanceResponse,
  CatalogResponse,
  CheckoutInput,
  PortalInput,
  UrlResponse,
} from '@/lib/api/types';

export { useUsage } from '@/lib/api/usage';

/** The offering of packages and credit packs (no Stripe price ids). */
export function useCatalog() {
  return useQuery({
    queryKey: ['billing', 'catalog', getActiveTenantId()],
    queryFn: () => apiFetch<CatalogResponse>('/billing/catalog'),
  });
}

/** The workspace's balance, weighted usage, credits, and enforcement status. */
export function useBalance() {
  return useQuery({
    queryKey: ['billing', 'balance', getActiveTenantId()],
    queryFn: () => apiFetch<BalanceResponse>('/billing/balance'),
  });
}

/** Starts a Stripe checkout session (by plan/pack key) and returns a redirect URL. */
export function useCheckout() {
  return useMutation({
    mutationFn: (input: CheckoutInput) =>
      apiFetch<UrlResponse>('/billing/checkout', { method: 'POST', body: input }),
  });
}

/** Opens the Stripe billing portal and returns a redirect URL. */
export function useBillingPortal() {
  return useMutation({
    mutationFn: (input: PortalInput) =>
      apiFetch<UrlResponse>('/billing/portal', { method: 'POST', body: input }),
  });
}
